// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-737fb398] .intercom-btn {\n  border: 1px solid #19191c;\n}\n[data-v-737fb398] body {\n  overflow-y: hidden !important;\n}\n", ""]);
// Exports
module.exports = exports;
